import { motion } from "framer-motion";
import { UserCheck, Brush, BarChart3 } from "lucide-react";
import type { NihaoBridgeContent } from "../content/types";

interface WhatWeDoSectionProps {
  content: NihaoBridgeContent["whatWeDo"];
}

const iconMap = {
  "person-badge": UserCheck,
  brush: Brush,
  "graph-up": BarChart3,
};

export default function WhatWeDoSection({ content }: WhatWeDoSectionProps) {
  return (
    <section
      className="w-full py-20 px-[5%] bg-gradient-to-b from-slate-50/50 to-slate-100/30"
      id="services"
    >
      <div className="max-w-6xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-3xl lg:text-4xl font-bold mb-12 text-center text-slate-900"
        >
          {content.title}
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {content.services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <motion.div
                key={service.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ y: -5 }}
                className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 text-center border border-slate-200/60 hover:border-cyan-400/30"
              >
                <div className="w-16 h-16 bg-cyan-500 rounded-full flex items-center justify-center mx-auto mb-6">
                  <IconComponent className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-semibold mb-4 text-slate-900">
                  {service.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {service.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
